<template>
  <b-navbar toggleable="md">
    <div class="container">
      <b-navbar-brand v-if=currentUser to="/">MightyGift</b-navbar-brand>
      <b-navbar-brand v-else :href="landingURL()">MightyGift</b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <template v-if=currentUser>
            <b-nav-item to="/settings">Settings</b-nav-item>
            <b-nav-item @click.prevent=logout href="/logout">Logout</b-nav-item>
          </template>
          <template v-else>
            <b-nav-item to="/login">Login</b-nav-item>
            <b-nav-item to="/signup">Signup</b-nav-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.currentUser !== undefined;
      },
    },
    methods: {
      landingURL() {
        return `${process.env.PROTOCOL}://${process.env.LANDING_HOST}`;
      },
      logout() {
        this.$store.dispatch('auth/logout');
      },
    },
  };
</script>

<style>
<style>


// WEBPACK FOOTER //
// src/components/shared/Navigation.vue